interface Listener {
  cb: () => any;
}

let listeners: Listener[] = [];

const useSaveButtonClicked = () => {
  const handleButtonClick = () => {
    listeners.forEach((listener) => {
      listener.cb();
    });
  };

  const addListener = (cb: any): Listener => {
    const listener = { cb };
    listeners.push(listener);
    return listener;
  };

  const removeListener = (listener: Listener) => {
    listeners.splice(listeners.indexOf(listener), 1);
  };

  return { onButtonClick: handleButtonClick, addListener, removeListener };
};

export default useSaveButtonClicked;
